<template>
  <div class="container">
      <div class="row">
        <div v-if="loading">
          <loader></loader>
        </div>
        <div v-else>
          <h1>Adicionar Usuários</h1>
          <hr/>
          <br/>
          <div class="row">
              <div class="col-md-6">
                <label for="select-items">Opções do select</label>
                <p class="text-muted">Adicione os usuários como linhas, com suas colunas separadas por ";" (ponto e vírgula) e os dados adicionais separados por "," (vírgula) no seguinte formato <b>login; nome; email; dados1, dado2, dado3</b></p>
                <p><strong>Ex: josedasilva@email.com; josedasilva@email.com; José da Silva; Professor, Ciências Naturais, Matemática</strong></p>
                <textarea id="select-items" v-model="csv" class="form-control" rows="6" placeholder="Insira os dados dos usuários"></textarea>
              </div>
              <div class="col-md-6">
                <label>Resultado - {{ users.length }} Usuário(s) identificado(s)</label>
                <p class="text-muted">Verifique se os itens foram reconhecidos corretamente.</p>
                <table class="table table-bordered table-sprited">
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>E-mail</th>
                      <th>Nome</th>
                      <th>Tags</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in users">
                      <td>{{user.username}}</td>
                      <td>{{user.email}}</td>
                      <td>{{user.name}}</td>
                      <td>
                        <ul class="list-unstyled">
                          <li v-for="tag in user.tags"><span class="label label-primary text-capitalize">{{ tag }}</span></li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
          <br/>
          <button class="btn btn-primary" @click="importUsers" :disabled="!users.length">Importar</button>
          <button class="btn btn-default" @click="$router.go(-1)">Voltar</button>
        </div>
      </div>
  </div>
</template>

<script>

import { Parse, miniToastr } from '../Global'
import Loader from './util/Loader'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader
  },
  data () {
    return {
      loading: false,
      users: [],
      csv: null
    }
  },
  watch: {
    csv (newValue) {
      let list = []
      let lines = newValue.split('\n')
      lines.forEach(line => {
        if (line) {
          let columns = line.split(';')
          let u = {
            username: columns[0],
            email: columns[1],
            name: columns[2]
          }
          u.tags = []
          if (columns[3]) {
            u.tags = columns[3].split(',').map(tag => tag.trim())
          }
          if (u.name && u.email) {
            list.push(u)
          }
        }
      })
      this.users = list
    }
  },
  methods: {
    importUsers () {
      let self = this
      self.loading = true
      let params = {
        users: self.users
      }
      Parse.Cloud.run('importUsers', params).then(results => {
        self.users = []
        self.csv = ''
        self.loading = false
        miniToastr.success('Usuários importados com sucesso.')
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    }
  }
}
</script>

<style scoped>
.label {
  margin-right: 3px 
}
</style>



// WEBPACK FOOTER //
// UserImport.vue?62071c56